import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
declare const Yiit: any;

@Component({
  selector: 'app-home-link',
  templateUrl: './home-link.component.html',
  styleUrls: ['./home-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeLinkComponent implements OnInit {

  public Yiit = Yiit;
  public show = false;

  constructor() { }

  ngOnInit() {
    this.show = window['IS_LOCAL_VERSION'];
  }

}
